import { mediaList } from '@/mocks/movies';
import type { Media, MediaType } from '@/types/media';

export const mediaData = mediaList as Media[];

export function getMediaById(id: string): Media | undefined {
  return mediaData.find((item) => item.id === id);
}

export function getMediaByType(type: string): Media[] {
  return mediaData.filter((item) => item.type === type);
}

export function getLatest(limit?: number): Media[] {
  const sorted = [...mediaData].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime(),
  );
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getHot(limit?: number): Media[] {
  const sorted = [...mediaData].sort((a, b) => b.rating - a.rating);
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getRelated(media: Media, limit = 4): Media[] {
  return mediaData
    .filter((item) => item.id !== media.id)
    .map((item) => {
      let score = 0;
      if (item.type === media.type) score += 3;
      if (item.region === media.region) score += 1;
      item.tags.forEach((tag) => {
        if (media.tags.includes(tag)) score += 2;
      });
      item.genres.forEach((genre) => {
        if (media.genres.includes(genre)) score += 2;
      });
      return { item, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((entry) => entry.item);
}

export function searchMedia(keyword: string): Media[] {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return mediaData.filter((item) => {
    const haystack = [item.title, item.director, item.region, ...item.genres, ...item.tags, ...item.cast]
      .join(' ')
      .toLowerCase();
    return haystack.includes(query);
  });
}

export interface FilterOptions {
  year?: string;
  region?: string;
  tag?: string;
}

export function filterMedia(type: MediaType, options: FilterOptions): Media[] {
  const { year = '全部', region = '全部', tag = '全部' } = options;
  return mediaData.filter((item) => {
    if (item.type !== type) return false;
    if (year !== '全部' && String(item.year) !== year) return false;
    if (region !== '全部' && item.region !== region) return false;
    if (tag !== '全部' && !item.tags.includes(tag) && !item.genres.includes(tag)) return false;
    return true;
  });
}

export const TYPE_DESCRIPTIONS: Record<MediaType, string> = {
  movie: '汇集院线热映与经典佳片，类型丰富、题材多元，快速了解最新电影内容与主创信息。',
  tv: '热门剧集持续更新，涵盖古装、悬疑、都市与历史等题材，追剧不迷路。',
  variety: '真人秀、音乐、美食与选秀等综艺节目一网打尽，轻松掌握最新一季看点。',
};

export const TYPE_SEO_TITLE: Record<MediaType, string> = {
  movie: '神马视频 - 电影分类 - 多元影视资源',
  tv: '神马视频 - 电视剧分类 - 多元影视资源',
  variety: '神马视频 - 综艺分类 - 多元影视资源',
};